import React, { useContext, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { BlobParam } from '../../utils/SiteTools';
import { EnvGet } from '../../utils/EnvGet';
import CategoryDemoContext from '../../utils/CategoryDemo/context';
import { lobDemoSplit } from '../../utils/LobLogicModule';
import { categoryList } from './data/categoryList.json';
import './CategoryList.scss';

const CategoryList = () => {
	const { categoryDemoData } = useContext(CategoryDemoContext);
	const sourceName = EnvGet();
	const { t/*, i18n*/ } = useTranslation('categoryList');
	const { search } = useLocation();
	const categoryLinkSpanishRef = useRef( [] ); 
	const moveToTop = () => {
		window.scrollTo(0, 0);
		document.getElementById('skip').focus();
	}

	useEffect(() => {
		categoryLinkSpanishRef.current.forEach((element) => {
			if(element.classList.contains('es')){
				element.innerHTML = "Ver";
			};
		});
	}, []);

	return (
		<div className="category-list-wrapper">
			{
				categoryDemoData.map(category => {
				const getCategoryLinkSpanishRef = (element) => (categoryLinkSpanishRef.current.push(element))
					return(
						<div className="category-item" key={category.path} lang={category.lang + "-US"}>
							<div className="category-icon--outer">
								<Link id={category.path} data-component="Category" to={lobDemoSplit+'/'+category.path+BlobParam(search)} key={category.path} className="category-link--cover t-track-cta" onClick={moveToTop} data-bactmln={"Category-_-CTA-_-"+category.path} aria-hidden="true" tabIndex="-1"></Link>
								<img className="category-icon" src={`${sourceName}${category.imgSmall}`} alt={category.imgSmallAltText ? category.imgSmallAltText : ''} />
							</div>
							<div className="category-title--outer">
								<h3 className="category-title" dangerouslySetInnerHTML={{ __html: category.name }}></h3>
							</div>
							<div className="category-copy--outer" dangerouslySetInnerHTML={{ __html: category.copyTeaser }}></div>
							<div className="category-link--outer">
								<Link ref={getCategoryLinkSpanishRef} id={category.path} data-component="Category" to={lobDemoSplit+'/'+category.path+BlobParam(search)} key={category.path} className={`category-link t-track-cta ${category.lang}`} onClick={moveToTop} data-bactmln={"Category-_-CTA-_-"+category.path} dangerouslySetInnerHTML={{ __html: t(categoryList.viewDemos) }}></Link>
							</div>
						</div>
					)
				})
			}
		</div>
	);
}

export default CategoryList;
